import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Opcion } from '../../models/opcion.model';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-single-selection',
  templateUrl: './single-selection.component.html',
  styleUrl: './single-selection.component.scss'
})
export class SingleSelectionComponent {

  @Input() options: Opcion[] = [];

  @Input() selected?: Opcion;
  @Output() selectedChange = new EventEmitter<Opcion>();

  public answerMaxLength: number = environment.limits.answerMaxLength;

  onSelect(option: Opcion) {
    this.selected = option;
    this.selectedChange.emit(option);
  }

}
